import React from "react";
import { useNavigate } from "react-router-dom";
import { notification, Form, Input, Button, Row, Col } from "antd";
import api from "../../utils/api";
const AddGuardUser = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  const onFinish = async (values) => {
    setLoading(true);

    const payload = {
      name: values.name,
      email: values.email,
      password: values.password,
      confirm_password: values.confirm_password,
      phone_number: values.phone_number,
      notes: values.notes || null,
    };

    try {
      await api.post("/users/guard", payload);

      notification.success({
        message: "Success",
        description: "Guard user added successfully!",
      });

      form.resetFields();
      navigate("/dashboard/userlist"); // or wherever you want
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Failed to add  uarduser. Please try again.";

      notification.error({
        message: "Error",
        description: msg,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pb-20 mx-6">
      <h3 className="font-bold text-[22px] mb-6">Add Guard User</h3>

      <div className="bg-white rounded-lg shadow-sm p-8 max-w-4xl mx-auto">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          {/* Name & Email */}
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Full Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter name!" },
                  { min: 2, message: "Name must be at least 2 characters!" },
                ]}
              >
                <Input placeholder="Enter full name" size="large" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input placeholder="guard@example.com" size="large" />
              </Form.Item>
            </Col>
          </Row>

          {/* Phone Number */}
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Phone Number"
                name="phone_number"
                rules={[
                  { required: true, message: "Please enter phone number!" },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Must be exactly 10 digits (e.g., 98XXXXXXXX)",
                  },
                ]}
              >
                <Input placeholder="98XXXXXXXX" maxLength={10} size="large" />
              </Form.Item>
            </Col>
          </Row>

          {/* Password & Confirm Password */}
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: "Please enter password!" },
                  { min: 6, message: "Password must be at least 6 characters!" },
                ]}
              >
                <Input.Password placeholder="Enter password" size="large" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                label="Confirm Password"
                name="confirm_password"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Please confirm password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Passwords do not match!"));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm password" size="large" />
              </Form.Item>
            </Col>
          </Row>

          {/* Notes */}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Notes (Optional)" name="notes">
                <Input.TextArea rows={4} placeholder="Any additional information..." />
              </Form.Item>
            </Col>
          </Row>

          {/* Submit */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              className="w-full bg-indigo-600 hover:bg-indigo-700"
            >
              {loading ? "Adding Guard..." : "Add Guard User"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AddGuardUser;